import { render, staticRenderFns } from "./LoginRegisterDialog.vue?vue&type=template&id=2cde302b&scoped=true"
import script from "./LoginRegisterDialog.vue?vue&type=script&lang=js"
export * from "./LoginRegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginRegisterDialog.vue?vue&type=style&index=0&id=2cde302b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde302b",
  null
  
)

export default component.exports